var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('commonTable',{ref:"commonTable",attrs:{"url":"admin/devices/activate_list","reqMethod":"GET","column":_vm.column,"searchColumn":_vm.searchColumn,"limitKey":"per_page"},on:{"isLoading":function (val) { return _vm.listLoading = val; }},scopedSlots:_vm._u([{key:"search",fn:function(scope){return [_c('el-button',{staticClass:"mb1",attrs:{"type":"success","plain":"","icon":"el-icon-download","loading":_vm.listLoading},on:{"click":function($event){return _vm.exportData({
          url: '/admin/devices/activate_list',
          name: '用户设备列表',
          column: _vm.column,
          limit: 'per_page',
          method: 'GET',},
          {
            totalRecords: scope.totalRecords,
            searchValue: Object.assign({}, scope.searchValue),
          })}}},[_vm._v("导出")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }